module.exports = __webpack_public_path__ + "3583451d5ba41549e6a47017882b3cd0.ttf";